var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7365 2.76172H8.08449C6.02449 2.76172 4.25049 4.43072 4.25049 6.49072V17.3397C4.25049 19.5157 5.90849 21.1147 8.08449 21.1147H16.0725C18.1325 21.1147 19.8025 19.3997 19.8025 17.3397V8.03772L14.7365 2.76172Z",
    stroke: "#185AC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4738 2.75V5.659C14.4738 7.079 15.6228 8.231 17.0428 8.234C18.3588 8.237 19.7058 8.238 19.7968 8.232",
    stroke: "#185AC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 12,
    height: 7,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.616 12.7276H8V11.5996H12.536V12.7276H10.92V17.1996H9.616V12.7276Z",
    fill: "#185AC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6154 14.3276L13.1034 11.5996H14.6234L15.6394 13.4716L16.6954 11.5996H18.1914L16.5834 14.3036L18.2794 17.1996H16.7354L15.5834 15.2076L14.4874 17.1996H12.9834L14.6154 14.3276Z",
    fill: "#185AC5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3113 12.7276H18.6953V11.5996H23.2313V12.7276H21.6153V17.1996H20.3113V12.7276Z",
    fill: "#185AC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.dfcc3d506149ebfb9cd82a65a900caff.svg";
export { ForwardRef as ReactComponent };